import {  SearchIcon} from "@chakra-ui/icons";
import {
    Flex,
    IconButton,
    InputGroup,
    InputLeftElement,
    useColorModeValue,
} from "@chakra-ui/react";

import React from "react";
import {SearchBar} from "./SearchBar";

export default function SearchWalletLinks(props) {
    const {  secondary, ...rest } = props;

    // Chakra Color Mode
    let mainTeal = useColorModeValue("teal.300", "teal.300");
    let inputBg = useColorModeValue("white", "gray.800");
    let searchIcon = useColorModeValue("gray.700", "gray.200");


    return (
        <Flex
            pe={{ sm: "16px", md: "16px" }}
            w={{ sm: "100%", md: "auto" }}
            alignItems="center"
            flexDirection="row"
        >
            {/*Поиск */}
            <InputGroup
                cursor="pointer"
                bg={inputBg} borderRadius="15px"
                w={{ sm: "128px", md: "200px", }}
                me={{ sm: "auto", md: "20px" }}
                _focus={{ borderColor: { mainTeal }, }}
                _active={{ borderColor: { mainTeal },  }}
            >
                <InputLeftElement
                    children={
                        <IconButton
                            bg="inherit" borderRadius="inherit"
                            _hover={{}}
                            _active={{ bg: "inherit", transform: "none", borderColor: "transparent", }}
                            _focus={{ boxShadow: "none", }}
                            icon={<SearchIcon color={searchIcon} w="15px" h="15px" />}
                        ></IconButton>
                    }
                />
                <SearchBar
                    initialValue={props.initialValue ?? ''}
                    onChange={props.onChange}
                    debounce={props.debounce}
                />
            </InputGroup>

        </Flex>
    );
}
